import React from "react";
import Newest from "./Sections/Newest/Newest";
import TopRead from "./Sections/TopRead/TopRead";

class Blog extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <>
        <Newest />
        <TopRead />
      </>
    );
  }
}
export default Blog;
